

import { useState } from "react";
import { quotationsApi } from "@/lib/api";
import { useToast } from "@/context/ToastContext";
import { ConvertEventData } from "../ConvertToEventModal";

interface Quotation {
  id: number;
  status?: string;
  quotation_number?: string;
}

export function useQuotationModals(quotation: Quotation) {
  const [isStatusPopupOpen, setIsStatusPopupOpen] = useState(false);
  const [isConvertModalOpen, setIsConvertModalOpen] = useState(false);
  const [isConvertLoading, setIsConvertLoading] = useState(false);
  const [convertError, setConvertError] = useState("");
  const { showToast } = useToast();

  const handleUpdateStatus = async (id: number, newStatus: string) => {
    if (!quotation.id) return;
    
    try {
      await quotationsApi.updateStatus(id, newStatus);
      showToast("Status updated successfully", "success");
      // Reload the page to show updated status
      window.location.reload();
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Failed to update status", "error");
    }
  };

  const handleConfirmConvert = async (data: ConvertEventData) => {
    if (!quotation.id) return;
    
    setIsConvertLoading(true);
    setConvertError("");
    
    try {
      await quotationsApi.convertToEvent(quotation.id, data);
      showToast("Event created successfully", "success");
      setIsConvertModalOpen(false);
      // Redirect to events page or the new event
      window.location.href = "/events";
    } catch (error: any) {
      console.error("Error converting to event:", error);
      setConvertError(error.message || "Failed to convert to event");
      showToast("Failed to convert to event", "error");
    } finally {
      setIsConvertLoading(false);
    }
  };

  const openStatusPopup = () => setIsStatusPopupOpen(true);
  const closeStatusPopup = () => setIsStatusPopupOpen(false);
  const openConvertModal = () => setIsConvertModalOpen(true);
  const closeConvertModal = () => {
    setIsConvertModalOpen(false);
    setConvertError("");
  };

  return {
    // State
    isStatusPopupOpen,
    isConvertModalOpen,
    isConvertLoading,
    convertError,
    
    // Actions
    handleUpdateStatus,
    handleConfirmConvert,
    openStatusPopup,
    closeStatusPopup,
    openConvertModal,
    closeConvertModal,
  };
}
